<template>
  <div>
    <b-breadcrumb v-if="!nobreadcrumb" :items="breadcrumb"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-card class="bg-light shadow">
      <b-card-title title-tag="h6">
        {{ title }}
        <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
      </b-card-title>
      <div class="d-flex justify-content-start align-items-center">
        <slot name="menu"></slot>
        <template v-if="!nosearch">
          <label class="mx-3 align-self-center">Rechercher : </label>
          <mh-input
            mh-class="w-25"
            autofocus
            append="🔍"
            @enter="submitInput(searchTable.search.value)"
            field="search"
            :table="searchTable"
            :autocomplete="{
              idHistory: autocomplete_idHistory,
              field: autocomplete_field,
            }"
          ></mh-input>
        </template>
      </div>
      <b-row v-if="rows.length > 0" class="mt-3">
        <b-col v-if="!nofacets && facets.length > 0" lg="2" class="no-print">
          <facets
            @clickFacet="narrow"
            title="Filtres"
            :context="title.toLowerCase()"
            :table="facets"
          ></facets>
        </b-col>
        <b-col :lg="!nofacets && facets.length > 0 ? 10 : 12">
          <list
            :nofilter="nofacets"
            @changePage="changePage"
            @removeFilter="removeFilter"
            @changeSort="changeSort"
            :fields="fields"
            :search="search"
            :filters="filters"
            :items="rows"
            :selectMode="selectMode"
            @row-clicked="$emit('row-clicked', $event)"
            :idTable="idTable"
            :key="render"
          >
            <template
              v-for="slotName in Object.keys($scopedSlots)"
              v-slot:[slotName]="slotScope"
            >
              <slot :name="slotName" v-bind="slotScope"></slot>
            </template>
            <template v-slot:cell(actions)="data">
              <template v-for="(entry, i) in actions">
                <template
                  v-if="
                    entry.condition == undefined || entry.condition(data.item)
                  "
                >
                  <b-button
                    :title="entry.label"
                    v-if="entry.action"
                    size="sm"
                    :icon="entry.icon ? true : false"
                    :class="entry.icon ? 'btn-xs mr-2' : 'mr-2'"
                    :key="i"
                    :variant="entry.variant ? entry.variant : ''"
                    @click="entry.action(data.item.ID)"
                  >
                    <b-icon v-if="entry.icon" :icon="entry.icon"></b-icon>
                    <span v-else>{{ entry.label }}</span>
                  </b-button>
                  <b-button
                    v-else
                    size="sm"
                    :icon="entry.icon ? true : false"
                    :class="entry.icon ? 'btn-xs mr-2' : 'mr-2'"
                    :variant="entry.variant ? entry.variant : ''"
                    :key="i"
                    :to="
                      entry.href
                        ? null
                        : {
                            name: entry.to,
                            params: {
                              id: data.item.mandat_ID || data.item.ID,
                              tab: entry.tab || null,
                            },
                          }
                    "
                    :href="
                      entry.href
                        ? entry.href.replace(
                            '{id}',
                            data.item.mandat_ID || data.item.ID
                          )
                        : '#'
                    "
                    :target="entry.href ? '_blank' : '_self'"
                    @click="entry.event ? $emit(entry.event, data.item) : null"
                    ><b-icon v-if="entry.icon" :icon="entry.icon"></b-icon>
                    <span v-else>{{ entry.label }}</span>
                  </b-button>
                </template>
              </template>
            </template>
          </list>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput.vue";
import List from "@/components/List.vue";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import Facets from "@/components/Facets.vue";
export default {
  name: "bd-table-list",
  computed: {},
  components: {
    MhInput,
    List,
    Facets,
  },
  props: {
    idTable: String,
    nofloatingPagination: {
      type: Boolean,
      default: false,
    },

    nobreadcrumb: {
      type: Boolean,
      default: false,
    },
    nofacets: {
      type: Boolean,
      default: false,
    },
    nosearch: {
      type: Boolean,
      default: false,
    },
    directLoad: {
      type: Boolean,
      default: true,
    },
    selectMode: String,
    hiddenFilter: String,
    query: Array,
    breadcrumb: Array,
    title: String,
    subtitle: String,
    autocomplete_idHistory: String,
    autocomplete_field: String,
    bdTable: String,
    fields: Array,
    Api: Object,
    actions: Array,
    defaultFilter: Array,
    defaultOrder: String,
    defaultSort: String,
    parameters: Object,
  },
  data() {
    return {
      searchTable: {},
      search: "",
      facets: [],
      filters: [],
      total: {},
      page: 1,
      rows: [],
      pagination: {},
      resultsInfo: "",
      loaded: true,
      sortBy: "ID",
      sortDesc: true,
      render: 0,
      busy: false,
      complete_data: null,
    };
  },
  created() {
    if (this.defaultOrder) {
      this.sortBy = this.defaultOrder;
    }
    if (this.defaultSort) {
      if (this.defaultSort == "DESC") {
        this.sortDesc = true;
      } else {
        this.sortDesc = false;
      }
    }
    if (!this.nosearch) {
      this.search = this.$route.params.search || "";
      // if (this.search == "" && localStorage.getItem(this.bdTable + "_search")) {
      //   let storage = JSON.parse(
      //     localStorage.getItem(this.bdTable + "_search")
      //   );
      //   this.search = storage.value;
      //   this.filters = this.defaultFilter || storage.filters;
      //   this.page = storage.page;
      //   this.sortBy = storage.sortBy;
      //   this.sortDesc = storage.sortDesc;
      // }
      this.searchTable = {
        search: {
          label: "",
          type: "varchar",
          value: this.search,
        },
      };
    } else {
      this.filters = this.query;
    }
    this.scroll();
    if (this.$props.directLoad) {
      this.loaded = false;
      this.submitSearch();
    }
  },
  watch: {
    $route(to) {
      this.search = to.params.search || "";
      this.submitSearch();
      // react to route changes...
    },
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    nActions(actions, item) {
      let n = 0;
      actions.forEach((el) => {
        if (el.condition == undefined || el.condition(item)) {
          n++;
        }
      });
      console.log(n);
      return n;
    },
    render_table() {
      this.render++;
    },
    submitInput(input) {
      if (input !== null) {
        this.search = this.searchTable.search.value;
      }
      this.reinit();
      this.submitSearch();
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch(false);
    },
    filtering(filter, sortBy = null, sortDesc = null) {
      this.filters = filter;
      if (sortBy) {
        this.sortBy = sortBy;
      }
      if (sortDesc) {
        this.sortDesc = sortDesc;
      }
      this.search = "";
      this.searchTable = {
        search: {
          label: "",
          type: "varchar",
          value: this.search,
        },
      };
      this.submitSearch();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },
    continueSearch() {
      this.busy = true;
      this.Api.search(
        [{ value: this.search }],
        this.filters,
        this.hiddenFilter ? this.hiddenFilter : "",
        this.page,
        this.sortBy,
        this.sortDesc,
        false,
        this.parameters
      )
        .then((response) => {
          this.rows = this.rows.concat(response.data.results.records);
          this.pagination = response.data.results.pagination;
          this.total = response.data.total ? response.data.total : null;
          this.busy = false;
          this.$emit("loaded");
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearch(fetchFacets = true, busy = true) {
      if (busy) {
        this.busy = true;
      }

      this.Api.search(
        [{ value: this.search }],
        this.filters,
        this.hiddenFilter ? this.hiddenFilter : "",
        this.page,
        this.sortBy,
        this.sortDesc,
        fetchFacets,
        this.parameters
      )
        .then((response) => {
          this.rows = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.total = response.data.total ? response.data.total : null;
          if (fetchFacets) {
            this.facets = response.data.facets;
          }

          this.loaded = true;
          if (this.pagination.totalRecords == 0) {
            this.resultsInfo = null;
          } else {
            this.resultsInfo = this.pagination.totalRecords;
          }
          this.busy = false;
          this.$emit("loaded");
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>
<style>
.position-absolute {
  position: fixed !important;
}
</style>

<style lang="scss" scoped>
</style>